var _style, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconViewOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2C3149;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,25.6c-0.1-0.1-0.1-0.2-0.2-0.4C7.9,25.3,7.9,25.5,8,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.7,24.8c0,0.1,0,0.2,0,0.3C7.8,25,7.8,24.9,7.7,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,25.2c0,0,0-0.1,0-0.1C7.8,25.1,7.8,25.2,7.8,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,24.4C7.8,24.3,7.8,24.3,7.8,24.4C7.8,24.3,7.8,24.3,7.8,24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,24.6c0-0.1,0-0.2,0-0.3C7.8,24.4,7.8,24.5,7.8,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,24c0,0,0,0.1-0.1,0.1C7.9,24.1,7.9,24,8,24C8,24,8,24,8,24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,24.6c0,0,0,0.1,0,0.1C7.7,24.7,7.8,24.7,7.8,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.1,23.8C8.1,23.8,8.1,23.8,8.1,23.8C8,23.9,8,23.8,8.1,23.8L8.1,23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.4,23.5c0,0-0.1,0.1-0.1,0.1L8.4,23.5C8.4,23.5,8.4,23.5,8.4,23.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.9,7.9c-0.2,0.8-1,1.3-1.8,1.1c-6.4-1.5-13,1.8-16.4,8c0.8,1.5,1.8,2.8,3,3.9c0.6,0.6,0.6,1.5,0,2.1 c-0.3,0.3-0.7,0.4-1.1,0.4c-0.4,0-0.8-0.1-1-0.4c-1.5-1.5-2.8-3.3-3.9-5.3c0,0,0-0.1-0.1-0.1c0,0,0-0.1-0.1-0.1c0,0,0-0.1,0-0.1 c0-0.1,0-0.1,0-0.1c0-0.2,0-0.4,0-0.6c0-0.1,0-0.1,0.1-0.2c0-0.1,0-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1C4.1,9.7,10.3,5.7,17,5.7 c1.3,0,2.5,0.1,3.8,0.4C21.6,6.3,22.1,7.1,21.9,7.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.4,16.5c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0c0,0,0-0.1-0.1-0.1c-1.5-2.9-3.6-5.4-6.2-7.2l5.9-5.9 c0.6-0.6,0.6-1.5,0-2.1c-0.6-0.6-1.5-0.6-2.1,0l-7.2,7.2l0,0l0,0L18.9,13L13,18.9l-4.6,4.6c0,0,0,0,0.1,0c0,0-0.1,0.1-0.1,0.1 l-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0-0.1,0.1c0,0,0,0,0,0l-7.1,7.1c-0.6,0.6-0.6,1.5,0,2.1c0.3,0.3,0.7,0.4,1.1,0.4 s0.8-0.2,1.1-0.4l6.5-6.5c2.4,1.2,4.9,1.7,7.5,1.7c6.7,0,12.9-4,16.3-10.6c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0.1-0.2 c0-0.1,0.1-0.2,0.1-0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0-0.1C33.5,16.6,33.4,16.5,33.4,16.5z M7.9,24.1 C7.9,24.1,7.9,24,7.9,24.1C8,24,8,24,8,24C8,24,7.9,24,7.9,24.1z M19.6,16.5c0,0.2,0,0.3,0,0.5c0,1.5-1.2,2.7-2.7,2.7 c-0.2,0-0.3,0-0.5,0L19.6,16.5z M17,25.3c-1.8,0-3.5-0.3-5.2-1l2.4-2.4c0.8,0.5,1.8,0.7,2.8,0.7c3.1,0,5.7-2.5,5.7-5.7 c0-1-0.3-2-0.8-2.8l3-3c2.2,1.4,4,3.4,5.3,5.9C27.4,22.2,22.4,25.3,17,25.3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,25.2c0,0,0-0.1,0-0.1C7.8,25.1,7.8,25.2,7.8,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,25.6c-0.1-0.1-0.1-0.2-0.2-0.4C7.9,25.3,7.9,25.5,8,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,24.6c0-0.1,0-0.2,0-0.3C7.8,24.4,7.8,24.5,7.8,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,24.4C7.8,24.3,7.8,24.3,7.8,24.4C7.8,24.3,7.8,24.3,7.8,24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.7,24.8c0,0.1,0,0.2,0,0.3C7.8,25,7.8,24.9,7.7,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,24.6c0,0,0,0.1,0,0.1C7.7,24.7,7.8,24.7,7.8,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,24c0,0,0,0.1-0.1,0.1C7.9,24.1,7.9,24,8,24C8,24,8,24,8,24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.1,23.8C8.1,23.8,8.1,23.8,8.1,23.8C8,23.9,8,23.8,8.1,23.8L8.1,23.8z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.4,23.5c0,0-0.1,0.1-0.1,0.1L8.4,23.5C8.4,23.5,8.4,23.5,8.4,23.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewOff);
export default __webpack_public_path__ + "static/media/icon-view-off.28c4a693b42f6cd6ffa9211c046a9d1f.svg";
export { ForwardRef as ReactComponent };